import { 
  Users, 
  BookOpen, 
  GraduationCap, 
  Tag, 
  TrendingUp, 
  Award, 
  Layers,
  ArrowUpRight,
  ShieldCheck,
  CheckCircle2
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Home = () => {
  const stats = [
    { title: "Jami Kurslar", value: "24", change: "+12%", icon: BookOpen, color: "text-blue-600 dark:text-blue-400", bg: "bg-blue-50 dark:bg-blue-950/40" },
    { title: "Faol Talabalar", value: "1,420", change: "+24%", icon: Users, color: "text-indigo-600 dark:text-indigo-400", bg: "bg-indigo-50 dark:bg-indigo-950/40" },
    { title: "Bitiruvchilar", value: "386", change: "+18%", icon: GraduationCap, color: "text-emerald-600 dark:text-emerald-400", bg: "bg-emerald-50 dark:bg-emerald-950/40" },
    { title: "Berilgan Sertifikatlar", value: "312", change: "+8%", icon: ShieldCheck, color: "text-amber-600 dark:text-amber-400", bg: "bg-amber-50 dark:bg-amber-950/40" },
  ];

  const quickLinks = [
    { title: "Darslar & Modullar", desc: "Modul va darslar ketma-ketligi", link: "/lessons", icon: Layers },
    { title: "Mentorlar Boshqaruvi", desc: "Katta dasturchi o'qituvchilar", link: "/mentors", icon: Users },
    { title: "Presales & Promokodlar", desc: "Chegirma va sotuv kampaniyalari", link: "/presales", icon: Tag },
    { title: "Kurs Nishonlari (Badges)", desc: "Gamifikatsiya va yutuqlar", link: "/badges", icon: Award },
  ];

  return (
    <div className="space-y-8">
      {/* Top Welcome Banner */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-gradient-to-r from-primary to-blue-600 rounded-3xl p-8 text-white shadow-sm relative overflow-hidden">
        <div className="relative z-10 max-w-xl space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">Xush kelibsiz, Boshqaruvchi!</h1>
          <p className="text-blue-100 text-sm leading-relaxed">
            01AI Admin tizimida platforma kurslari, o'qituvchilar, testlar va barcha sotuv kampaniyalarini qulay boshqaring.
          </p>
        </div>
        <div className="relative z-10 flex gap-3">
          <Link to="/lessons">
            <Button className="bg-white text-primary hover:bg-white/90 font-semibold rounded-xl gap-2 shadow-sm">
              <BookOpen className="size-4" /> Darslarni Ko'rish
            </Button>
          </Link>
        </div>
        <div className="absolute right-0 bottom-0 opacity-10 pointer-events-none translate-x-8 translate-y-8">
          <TrendingUp className="size-80" />
        </div>
      </div>

      {/* KPI Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, i) => (
          <div key={i} className="bg-card text-card-foreground rounded-2xl p-6 border border-border shadow-sm flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">{stat.title}</p>
              <h3 className="text-2xl font-bold text-foreground">{stat.value}</h3>
              <div className="flex items-center gap-1 text-xs text-emerald-500 font-semibold pt-1">
                <TrendingUp className="size-3" /> {stat.change} bu oy
              </div>
            </div>
            <div className={`size-14 rounded-2xl ${stat.bg} ${stat.color} flex items-center justify-center`}>
              <stat.icon className="size-7" />
            </div>
          </div>
        ))}
      </div>

      {/* Quick Navigation Cards */}
      <div>
        <h2 className="text-lg font-bold text-foreground mb-4 tracking-tight">Tezkor Boshqaruv Bo'limlari</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickLinks.map((item, idx) => (
            <Link
              to={item.link}
              key={idx}
              className="bg-card text-card-foreground rounded-2xl p-6 border border-border shadow-sm hover:border-primary/50 hover:shadow-md transition-all group flex flex-col justify-between"
            >
              <div className="space-y-3">
                <div className="size-12 rounded-xl bg-muted group-hover:bg-primary/10 text-muted-foreground group-hover:text-primary flex items-center justify-center transition-colors">
                  <item.icon className="size-6" />
                </div>
                <div>
                  <h4 className="font-bold text-foreground group-hover:text-primary transition-colors flex items-center justify-between">
                    {item.title}
                    <ArrowUpRight className="size-4 opacity-0 group-hover:opacity-100 transition-opacity text-primary" />
                  </h4>
                  <p className="text-xs text-muted-foreground mt-1">{item.desc}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* System Status & Overview */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-card text-card-foreground rounded-2xl p-6 border border-border shadow-sm space-y-4">
          <h3 className="font-bold text-foreground text-base">Tizim Ishlash Holati</h3>
          <div className="space-y-3">
            {[
              { service: "Real-time Bildirishnoma Streami (SSE)", status: "Faol va ulanmoqda", ok: true },
              { service: "Kurs & Darslar API V1", status: "Barcha xizmatlar normada", ok: true },
              { service: "Avtomatik Sertifikat Generatori", status: "Faol", ok: true },
              { service: "Presales & Promocode Engine", status: "Chegirmalar hisoblanmoqda", ok: true },
            ].map((srv, idx) => (
              <div key={idx} className="flex items-center justify-between p-3.5 rounded-xl bg-muted/40 border border-border">
                <div className="flex items-center gap-3">
                  <CheckCircle2 className="size-5 text-emerald-500" />
                  <span className="text-sm font-medium text-foreground">{srv.service}</span>
                </div>
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-emerald-500/10 text-emerald-500 border border-emerald-500/20">
                  {srv.status}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-card text-card-foreground rounded-2xl p-6 border border-border shadow-sm space-y-4 flex flex-col justify-between">
          <div className="space-y-2">
            <h3 className="font-bold text-foreground text-base">Yangi Versiya V2.0</h3>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Barcha modullar API hujjatlariga muvofiq to'liq integratsiya qilindi. Multi-language (UZ, RU, EN) va Dark/Light rejim qo'llab-quvvatlanadi.
            </p>
          </div>
          <div className="p-4 rounded-xl bg-primary/10 border border-primary/20">
            <p className="text-xs font-semibold text-primary">Dizayn to'liq moslashtirildi</p>
            <p className="text-[11px] text-muted-foreground mt-1">Interfeys yorug' va tungi rejimda chiroyli ko'rinadi.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
